// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gn21","left":"styles_left__3gaCV","desktopActions":"styles_desktopActions__3Ci1u","title":"styles_title__3vauw"};